<div class="cont">
  <div class="spinner"></div>
  <span class="number"></span>
</div>